import { render, staticRenderFns } from "./GenderReport.vue?vue&type=template&id=f748e172&scoped=true"
import script from "./GenderReport.vue?vue&type=script&lang=js"
export * from "./GenderReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f748e172",
  null
  
)

export default component.exports